/* @generated */

// ../src/skeleton/skeleton_box.tsx
import * as React2 from "react";

// ../src/skeleton/skeleton_base.tsx
import * as React from "react";
import cx from "classnames";
import { useTheme } from "@dropbox/dig-foundations";

// ../src/skeleton/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var baseSkeletonCls = _7a468({ defaultClassName: "dig-xxwt2ad_21-7-0", variantClassNames: { shouldAnimate: { false: "dig-xxwt2ae_21-7-0", true: "dig-xxwt2af_21-7-0" }, mode: { dark: "dig-xxwt2ag_21-7-0", bright: "dig-xxwt2ah_21-7-0" }, withBorderRadius: { xsmall: "dig-xxwt2a6_21-7-0", small: "dig-xxwt2a7_21-7-0", medium: "dig-xxwt2a8_21-7-0", large: "dig-xxwt2a9_21-7-0", xlarge: "dig-xxwt2aa_21-7-0", circular: "dig-xxwt2ab_21-7-0", false: "dig-xxwt2ac_21-7-0" } }, defaultVariants: { shouldAnimate: true, mode: "bright" }, compoundVariants: [] });
var skeletonAvatarClipPath = "var(--dig-xxwt2a4_21-7-0)";
var skeletonAvatarCls = _7a468({ defaultClassName: "dig-xxwt2at_21-7-0", variantClassNames: { size: { xsmall: "dig-xxwt2ap_21-7-0", small: "dig-xxwt2aq_21-7-0", medium: "dig-xxwt2ar_21-7-0", large: "dig-xxwt2as_21-7-0" } }, defaultVariants: { size: "medium" }, compoundVariants: [] });
var skeletonTextCls = _7a468({ defaultClassName: "dig-xxwt2a12_21-7-0", variantClassNames: { size: { xsmall: "dig-xxwt2ay_21-7-0", small: "dig-xxwt2az_21-7-0", medium: "dig-xxwt2a10_21-7-0", large: "dig-xxwt2a11_21-7-0" } }, defaultVariants: { size: "medium" }, compoundVariants: [] });

// ../src/skeleton/skeleton_base.tsx
import { atoms } from "@dropbox/dig-foundations";
var SkeletonBase = ({
  className,
  withBorderRadius = "xsmall",
  borderRadius = "XSmall",
  shouldAnimate = true,
  height,
  width,
  style,
  padding,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  paddingX,
  paddingY,
  ...rest
}) => {
  const { mode } = useTheme();
  const _styles = {};
  if (height) {
    _styles["height"] = `${Math.min(height, 200)}px`;
  }
  if (width) {
    _styles["maxWidth"] = `${Math.min(width, 330)}px`;
  }
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      style: { ..._styles, ...style },
      className: cx(
        "dig-Skeleton",
        atoms({ padding, paddingBottom, paddingLeft, paddingRight, paddingTop, paddingX, paddingY }),
        baseSkeletonCls({
          withBorderRadius,
          mode,
          shouldAnimate
        }),
        atoms({ borderRadius }),
        className,
        {
          ["dig-Skeleton--dark"]: mode === "dark",
          ["dig-Skeleton--shouldAnimate"]: shouldAnimate,
          [`dig-Skeleton--withBorderRadius-${withBorderRadius}`]: withBorderRadius !== void 0 && withBorderRadius !== false
        }
      ),
      ...rest
    }
  );
};
SkeletonBase.displayName = "SkeletonBase";

// ../src/skeleton/skeleton_box.tsx
var Box = ({ ...rest }) => {
  return /* @__PURE__ */ React2.createElement(SkeletonBase, { ...rest });
};
Box.displayName = "Box";

// ../src/skeleton/skeleton_text.tsx
import * as React3 from "react";
import cx2 from "classnames";
var Text = ({ className, size = "medium", ...rest }) => {
  return /* @__PURE__ */ React3.createElement(
    SkeletonBase,
    {
      className: cx2(
        `dig-Skeleton__text dig-Skeleton__text--${size}`,
        skeletonTextCls({ size }),
        className
      ),
      ...rest
    }
  );
};
Text.displayName = "Text";

// ../src/skeleton/skeleton_avatar.tsx
import * as React4 from "react";
import cx3 from "classnames";
import { useSquircleClipPath } from "@dropbox/dig-components/avatar";
import { assignInlineVars } from "@vanilla-extract/dynamic";
var Avatar = ({
  className,
  size = "medium",
  style,
  ...rest
}) => {
  const { clipPathUrl, clipPath } = useSquircleClipPath();
  return /* @__PURE__ */ React4.createElement(
    SkeletonBase,
    {
      ...rest,
      style: {
        ...assignInlineVars({
          [skeletonAvatarClipPath]: clipPathUrl || ""
        }),
        ...style
      },
      className: cx3(
        `dig-Skeleton__avatar dig-Skeleton__avatar--${size}`,
        skeletonAvatarCls({
          size
        }),
        className
      ),
      borderRadius: "Circular"
    },
    clipPath
  );
};
Avatar.displayName = "Avatar";

// ../src/skeleton/skeleton.tsx
var Skeleton = {
  Box,
  Text,
  Avatar
};
export {
  Skeleton
};
